/* eslint-disable @typescript-eslint/no-unused-vars */
export default function fun(_) {
  return Promise.reject(new Error('@uni：file.openDocument暂不支持'));
}